import { HeaderButton } from '@/components'
import { Icon, useDisclosure } from '@chakra-ui/react'
import { faArrowUpFromArc } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useGetUser } from 'BrokerTsLib/src/hooks/useUser'
import { UserTransferModal } from './UserTransferModal'

export const UserTransferButton = ({ userId, organizationUnitId }: { userId: string, organizationUnitId?: number }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const { refetch } = useGetUser(userId)

  return (
    <>
      <HeaderButton onClick={onOpen} title="Přesunout do jiné organizace">
        <Icon as={FontAwesomeIcon} icon={faArrowUpFromArc} size="lg" color="secondary.500" />
        Přesunout
      </HeaderButton>

      <UserTransferModal
        userIds={[userId]}
        organizationUnitId={organizationUnitId}
        isOpen={isOpen}
        onClose={onClose}
        transferSuccessCallback={refetch}
      />
    </>
  )
}